import { useEffect } from 'react'
import { getErrorMessageOmiseCharge } from 'helpers/omiseCharge'
import useScript from 'hooks/useScripts'
import { UseScriptStatusEnum } from 'enums'

const useOmise = ({ omisePublicKey }) => {
  const status = useScript('https://cdn.omise.co/omise.js')

  useEffect(() => {
    if (status === UseScriptStatusEnum.ready) {
      window.Omise.setPublicKey(omisePublicKey)
    }
  }, [omisePublicKey, status])

  function createToken({ card, onSuccess, onFailure = () => {} }) {
    return window.Omise.createToken('card', card, async function (statusCode, response) {
      if (statusCode === 200) {
        onSuccess({ token: response.id })
      } else {
        // Error: display an error message. Note that `response.message` contains
        // a preformatted error message. Also note that `response.code` will be
        // "invalid_card" in case of validation error on the card.

        const errorMessage = getErrorMessageOmiseCharge(response.code)
        onFailure({
          errorMessage,
          errorCode: response.code,
          errorMessageFromOmise: response.message,
        })
      }
    })
  }

  return {
    createToken,
  }
}

export default useOmise
